export default __webpack_public_path__ + "static/media/ed1.abeb4227.jpg";